import { useState, useEffect } from "react";

export const useFacebookData = (pageId, postId, accessToken) => {
  const [data, setData] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentsIDs, setCommentsIDs] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFacebookData = async () => {
      try {
        const response = await fetch(
          `https://graph.facebook.com/v20.0/${pageId}_${postId}/comments?access_token=${accessToken}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch Facebook data");
        }
        const result = await response.json();
        setData(result);
        const fetchedComments = result.data.map((item) => item.message);
        const fetchedCommentsIDs = result.data.map((item) => item.id);
        setComments(fetchedComments);
        setCommentsIDs(fetchedCommentsIDs);
      } catch (err) {
        setError(err.message);
      }
    };

    if (pageId && postId && accessToken) {
      fetchFacebookData();
    }
  }, [pageId, postId, accessToken]);

  return { data, comments, commentsIDs, error };
};

// Add more social media fetching functions here, e.g.:
// export const useTwitterData = ...
// export const useInstagramData = ...
